import React from "react";
import "./FinalScope.css";
import { appendTest } from "../../store/actions/collectTestResults";
import {
  COLLECT_TESTS, SHOW_TOAST
} from "../../store/actions/types";
import { connect } from "react-redux";
import firebase from "../../store/firebase";
import { addMorePoints } from '../../store/actions/freshCardActions'
import { showToast } from '../../store/actions/toastAction'
import { updateTestAttempt } from '../../store/actions/testAttemptActions'
import { getPassingThreshold, calculateTestPassed, calculateLCEarned, getDifficultyInfo, getMaxRetryAttempts } from '../../utils/test_utils';

class FinalScope extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      userConfirmedSubmission: false,
      testPassed: false,
      showConfirmation: false,
      testProcessed: false,
      cheat: false
    };
  }

  // Helper method to check if user is taking their own test
  isOwnTest = () => {
    const isOwnTest = this.props.personid === this.props.publisherid;
    
    
    
    
    return isOwnTest;
  }

  componentDidMount(){
    
    
    
    
    
    
          
    
    
    // Initialize test handling
    this.handleTestCompletion();
    // Notify parent (DoTest) that final screen is active; disable exit confirmations
    try { if (typeof this.props.onTestComplete === 'function') this.props.onTestComplete(); } catch (e) {}
  }

  componentDidUpdate(prevProps) {
    // Reset state and handle test completion if test results have changed
    const currentTestKey = `${this.props.counterCorrectAnswers}-${this.props.counterIncorrectAnswers}-${this.props.surveyid}`;
    const prevTestKey = `${prevProps.counterCorrectAnswers}-${prevProps.counterIncorrectAnswers}-${prevProps.surveyid}`;
    
    if (currentTestKey !== prevTestKey) {
      
      this.setState({
        userConfirmedSubmission: false,
        testPassed: false,
        showConfirmation: false,
        testProcessed: false
      }, () => {
        this.handleTestCompletion();
      });
    }
  }

  handleTestCompletion = () => {
    // Always calculate test results first, regardless of publisher
    const totalAnswered = Math.max(0, parseInt(this.props.counterCorrectAnswers || 0) + parseInt(this.props.counterIncorrectAnswers || 0));
    
    // Safety check for division by zero
    if (totalAnswered === 0) {
      
      this.setState({ testPassed: false });
      return;
    }
    
    // Get test difficulty from props (default to 'basic' if not provided)
    const testDifficulty = this.props.testComplexity || this.props.difficulty || 'basic';
    const difficultyInfo = getDifficultyInfo(testDifficulty);
    
    // Use utility function to calculate if test passed based on difficulty
    const testPassed = calculateTestPassed(
      parseInt(this.props.counterCorrectAnswers), 
      totalAnswered, 
      testDifficulty
    );
    
    const passRate = totalAnswered > 0 ? (parseInt(this.props.counterCorrectAnswers || 0) / totalAnswered) : 0;
    
    
    
    
    
    
    
    
    
    
    // 🚨 CRITICAL: Auto-increment attempt counter when test is completed
    // Skip for owners so they can retry unlimited times without exhausting attempts
    const isUserTakingOwnTest = this.isOwnTest();
    if (!isUserTakingOwnTest) {
      this.autoIncrementAttempt(testPassed, testDifficulty);
    } else {
      
    }
    
    // Update state with test results and show confirmation UI
    this.setState({ 
      testPassed: testPassed,
      showConfirmation: true 
    });
    }

  // Auto-increment attempt counter when test is completed (not when user clicks OK)
  autoIncrementAttempt = async (testPassed, testDifficulty) => {
    

    try {
      // Get current attempt data
      const isCompanyID = this.props.real_companyID || this.props.companyID;
      const maxRetryAttempts = getMaxRetryAttempts(testDifficulty);
      const maxAttempts = maxRetryAttempts + 1;
      
      // Current attempt that just completed
      const currentAttempt = this.props.currentAttempt || 1;
      
      // This completion marks the end of currentAttempt
      // Store how many attempts have been completed
      const completedAttempts = currentAttempt;
      
      
      
      const updateData = {
        attemptNumber: completedAttempts, // Store completed attempts, not next attempt
        lastCompletedAt: Date.now(),
        status: testPassed ? 'completed_passed' : 'completed_failed',
        testPassed: testPassed,
        passRate: (parseInt(this.props.counterCorrectAnswers) / (parseInt(this.props.counterCorrectAnswers) + parseInt(this.props.counterIncorrectAnswers)) * 100).toFixed(1)
      };

      // Check if retries are exhausted (no more attempts allowed)
      if (completedAttempts >= maxAttempts) {
        updateData.status = 'retries_exhausted';
        updateData.retriesExhausted = true;
        
        
      } else {
        
      }

      // Update test attempt in database
      await this.props.updateTestAttempt({
        surveyid: this.props.surveyid,
        personid: this.props.personid,
        companyID: this.props.companyID,
        real_companyID: this.props.real_companyID,
        updates: updateData
      });

      

    } catch (error) {
      
      // Don't block the UI, just log the error
    }
  }

checkTestDone = async (
  isCompanyID,
  surveyid,
  personid,
  thoughtID
) => {
  try {
    const snapshot = await firebase
      .database
      .ref(`surveysTests/${isCompanyID}/${surveyid}/${personid}`)
      .once("value");
    console.log('checkTestDone 1: ', isCompanyID);

    if (!snapshot.exists()) return false;

    const data = snapshot.val();
    console.log('checkTestDone 2: ', data);
    console.log('checkTestDone 3: ', data.testPassed);

    return data.thoughtID === thoughtID && data.testPassed === true;

  } catch (error) {
    console.error(error);
    return false;
  }
};

checkGroupTestDone = async (
  companyID,
  groupID,
  surveyid,
  personid,
  thoughtID
) => {
  try {
    const snapshot = await firebase
      .database
      .ref(`surveysTests/${companyID}/${groupID}/${surveyid}/${personid}`)
      .once("value");

    if (!snapshot.exists()) return false;

    const data = snapshot.val();

    return data.thoughtID === thoughtID && data.testPassed === true;

  } catch (error) {
    console.error("Error checking group test:", error);
    return false;
  }
};

  handleConfirmSubmission = async() => {
    
    var getLc = true;
    const isUserTakingOwnTest = this.isOwnTest();
    
    var isCompanyID;
    if (this.props.real_companyID) {
      isCompanyID = this.props.real_companyID;
    } else {
      isCompanyID = this.props.companyID;
    }

    this.setState({ 
      userConfirmedSubmission: true,
      showConfirmation: false,
      testProcessed: true 
    });
    
    // For users taking their own test, do NOT save completion (they can take it again)
    if (isUserTakingOwnTest) {
      
      
      return; // Exit early - no submission, no points
    }
    
    // Save test completion when user clicks OK to prevent retaking (only for non-creators)
    const totalAnswered = parseInt(this.props.counterCorrectAnswers) + parseInt(this.props.counterIncorrectAnswers);
    const testDifficulty = this.props.testComplexity || this.props.difficulty || 'basic';
    const testPassed = this.state.testPassed;
    const lcEarned = testPassed ? Math.max(0, (this.finalPoints() / 100)) : 0;
    var params = {
      type: COLLECT_TESTS,
      surveyid: this.props.surveyid,
      companyID: isCompanyID,
      groupID: this.props.thoughtID || this.props.groupID,
      personid: this.props.personid,
      counterCorrectAnswers: this.props.counterCorrectAnswers,
      surveyTitle: this.props.title || '',
      personName: this.props.personName,
      personLname: this.props.personLname,
      qlen: this.props.qlen,
      totalAnswered: totalAnswered,
      difficulty: testDifficulty,
      testPassed: testPassed,
      lcEarned: lcEarned,
      timestamp: Date.now(),
      thoughtID: this.props.thoughtID,
      title: this.props.title
    };
    console.log('appendTest params: ', params);
    
      //CHECK FOR Lc FRAUDULANT TEST SUBMITTED///////////////////////////////////////////
      const exists = await this.checkTestDone(
        params.companyID,
        params.surveyid,
        params.personid,
        params.thoughtID
      );

      const exists_group = await this.checkGroupTestDone(
        params.companyID,
        params.groupID,
        params.surveyid,
        params.personid,
        params.thoughtID
      );

      if (exists || exists_group) { //test already done
        console.log("checkTestDone 4: Test already completed");
        this.setState({
           testPassed: false,
           cheat: true,
           showConfirmation: true
        });
        getLc = false;
      }
      else {  //not completed yet
        this.props.appendTest(params);
      }
      ///////////////////////////////////////////////////////////////////////////////////
    
     
    // Update points ONLY if test passed AND user confirmed (clicked OK)
    if (this.state.testPassed && getLc === true) {
      console.log("checkTestDone 5: Lc earned");
      
      if (this.props.userdata.execmember === true) {
        var earnedPoints = this.finalPoints();
        
        if (earnedPoints > 0) {
          var pointsParams = {
            uid: this.props.uid,
            userID: this.props.personid,
            pointsCurrent: this.props.points ? this.props.points : 0,
            ypointsCurrent: this.props.pointsy? this.props.pointsy : 0,
            pointsAdded: earnedPoints,
            // Use transactional increments and ignore passed current totals to avoid scaling errors
            forceAward: true,
            company_id: this.props.userdata.companyName,
            companyName: this.props.userdata.companyName, 
            firstName: this.props.userdata.firstName,
            lastName: this.props.userdata.lastName,
            useremail: this.props.userdata.email,
            title: this.props.title,
            thoughtType: this.props.thoughtType,
            trailID: this.makeid(10),
            actionType: 'Test Passed',
            actionDesc: this.props.title + ' Test'
          };
          
          this.props.addMorePoints(pointsParams);
          

          if (this.props.showLeadb) {
            
            this.props.showLeadb(this.props, pointsParams.pointsAdded);
          }
        } else {
          
        }
      } else {
        
        
      }
    }
  }

  handleCancelSubmission = () => {
    
    
    // Get test difficulty from props (with fallback)
    const testDifficulty = this.props.testComplexity || this.props.difficulty || 'basic';
    const maxRetryAttempts = getMaxRetryAttempts(testDifficulty);
    const difficultyInfo = getDifficultyInfo(testDifficulty);
    
    // Advanced difficulty check: No retries allowed ever
    if (maxRetryAttempts === 0) {
      
      alert(`${difficultyInfo.displayName} difficulty does not allow any retries. Tests are final on the first attempt.`);
      this.setState({ 
        userConfirmedSubmission: false,
        showConfirmation: false,
        testProcessed: true 
      });
      return;
    }
    
    // Check if retries are available (only if we have retry info from props)
    if (this.props.retryInfo && !this.props.retryInfo.canRetry) {
      
      alert(`You have used all ${this.props.retryInfo.maxAttempts} attempts for ${difficultyInfo.displayName} difficulty. No more retries are allowed.`);
      this.setState({ 
        userConfirmedSubmission: false,
        showConfirmation: false,
        testProcessed: true 
      });
      return;
    }
    
    // Call the resetTest function from Survey component if available
    if (this.props.resetTest) {
      const resetSuccessful = this.props.resetTest();
      if (!resetSuccessful) {
        
        alert('No more retries are available for this test difficulty.');
        this.setState({ 
          userConfirmedSubmission: false,
          showConfirmation: false,
          testProcessed: true 
        });
        return;
      }
    }
    
    this.setState({ 
      userConfirmedSubmission: false,
      showConfirmation: false,
      testProcessed: true 
    });
    
    
    if (this.props.retryInfo) {
      
      
    }
  }

  handleExitFailedTest = () => {
    
    this.setState({ 
      userConfirmedSubmission: false,
      showConfirmation: false,
      testProcessed: true 
    });
    
    
  }

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

  finalPoints = () => {
    var points;
    var lcPoints;
    // Use the same calculation as the pass/fail logic - answered questions, not total questions
    const totalAnswered = parseInt(this.props.counterCorrectAnswers) + parseInt(this.props.counterIncorrectAnswers);
    
    // Get test difficulty from props (default to 'basic' if not provided)
    const testDifficulty = this.props.testComplexity || this.props.difficulty || 'basic';
    
    // Use utility function to calculate if test passed and LC earned
    const testPassed = calculateTestPassed(
      parseInt(this.props.counterCorrectAnswers), 
      totalAnswered, 
      testDifficulty
    );
    
    if (testPassed) {
      const lcEarned = calculateLCEarned(parseInt(this.props.counterCorrectAnswers), testPassed, testDifficulty);
      lcPoints = lcEarned * 100; // Convert to points (multiply by 100)
    } else {
      lcPoints = 0;
    }
    
    
    return lcPoints;
   }

  render() {
    const { appendTest } = this.props;
    const { cheat } = this.state;
    // Calculate pass/fail status using state
    const totalQuestions = Math.max(0, parseInt(this.props.counterCorrectAnswers || 0) + parseInt(this.props.counterIncorrectAnswers || 0));
    const passRate = totalQuestions > 0 ? (parseInt(this.props.counterCorrectAnswers || 0) / totalQuestions) : 0;
    const isPassed = this.state.testPassed;
   // const cheating = cheat;
    const cheating = cheat === true;
   console.log('checkTestDone 6: ', cheating);

    const message = cheating
      ? "Duplicate test attempted"
      : (this.state.testPassed ? "PASSED!" : "FAILED!");

    const userSubmitted = this.state.userConfirmedSubmission;
    const lcEarned = this.finalPoints() / 100;
    
    var finalP;
    if (isPassed) {
      finalP = 'blue';  //PASSED
    }
    else
    {
      finalP = 'red'; //FAILED
    }
    //   var params = {
    //     uid: this.props.uid,
    //     userID: this.props.personid,
    //     pointsCurrent: this.props.points,
    //     pointsAdded: this.finalPoints()
    //   }
    //  this.props.addMorePoints(params);

    // Show confirmation dialog when test is completed but not yet processed
    if (this.state.showConfirmation) {
      const isUserTakingOwnTest = this.isOwnTest();
      
      return (
        <div style={{
          width: '100%', 
          textAlign: 'center',
          backgroundColor: '#ffffff',
          padding: '20px',
          border: '2px solid #ddd',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
        }}>
          {/* <div style={{ color: finalP, fontSize: '24px', fontWeight: 'bold', marginBottom: '15px' }}>
            {isPassed ? "PASSED!" : "FAILED!"}
          </div> */}
          <div style={{ color: finalP, fontSize: '24px', fontWeight: 'bold', marginBottom: '15px' }}>
              {message}
          </div>
          <div style={{ color: finalP, marginBottom: '10px', fontSize: '16px' }}>
            <b>Test Analysis:</b> Correct: {this.props.counterCorrectAnswers} | Wrong: {this.props.counterIncorrectAnswers}
          </div>
          <div style={{ color: finalP, fontSize: '14px', marginBottom: '15px' }}>
            {this.props.personName + ' ' + this.props.personLname} of {this.props.companyName}
          </div>

          {isUserTakingOwnTest ? (
            // Special messaging for test creators
            <div style={{ fontSize: '16px', marginBottom: '20px', color: '#ff9800', backgroundColor: '#fff3e0', padding: '15px', borderRadius: '5px', border: '2px solid #ffcc80' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>📝 You are viewing your own test</div>
              <div style={{ fontSize: '14px' }}>
                As the test creator, you can see the results but cannot submit for points. 
                You can retake this test anytime to review your questions.
              </div>
            </div>
          ) : (
            // Normal messaging for regular test takers
            <div style={{ fontSize: '16px', marginBottom: '20px', color: '#333' }}>
              {(() => {
                const testDifficulty = this.props.testComplexity || this.props.difficulty || 'basic';
                const difficultyInfo = getDifficultyInfo(testDifficulty);
                // Determine retries left using provided retryInfo, or fall back to current/max attempts
                const retriesLeft = (this.props.retryInfo && typeof this.props.retryInfo.retriesLeft === 'number')
                  ? this.props.retryInfo.retriesLeft
                  : Math.max(0, ((this.props.maxAttempts || 0) - (this.props.currentAttempt || 0)));
                const retriesAvailable = retriesLeft > 0;

                if (isPassed) {
                  return retriesAvailable
                    ? 'You PASSED the test. Select CANCEL if you want to redo the test or select OK to submit.'
                    : `You PASSED the test. No retries remaining for ${difficultyInfo.displayName} difficulty. Select OK to submit and earn your LC.`;
                }

                if (!retriesAvailable) {
                  const noRetriesAllowed = getMaxRetryAttempts(testDifficulty) === 0;
                  return `You need to achieve at least ${difficultyInfo.threshold}% to pass this ${difficultyInfo.displayName.toLowerCase()} level test. ${noRetriesAllowed ? 'No retries are allowed for this difficulty.' : 'You have no retries remaining.'} Please select EXIT.`;
                }
                return `You need to achieve at least ${difficultyInfo.threshold}% to pass this ${difficultyInfo.displayName.toLowerCase()} level test. Would you like to redo the test or exit?`;
              })()}
            </div>
          )}
          
          {/* Show retry information at the top center for failed tests */}
          {!isPassed && this.props.retryInfo && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '12px'
            }}>
              <div style={{
                padding: '8px 12px',
                backgroundColor: '#e3f2fd',
                border: '1px solid #2196F3',
                borderRadius: '5px',
                fontSize: '11px',
                textAlign: 'center',
                minWidth: '140px',
                maxWidth: '180px'
              }}>
                <div style={{ marginBottom: '3px' }}>
                  <strong>Attempt:</strong> {this.props.retryInfo.currentAttempt}/{this.props.retryInfo.maxAttempts}
                </div>
                {(() => {
                  const testDifficulty = this.props.testComplexity || this.props.difficulty || 'basic';
                  const maxRetryAttempts = getMaxRetryAttempts(testDifficulty);
                  const difficultyInfo = getDifficultyInfo(testDifficulty);
                  
                  if (maxRetryAttempts === 0) {
                    return <div><strong>{difficultyInfo.displayName}:</strong> No retries</div>;
                  } else {
                    return <div><strong>Retries left:</strong> {this.props.retryInfo.retriesLeft}</div>;
                  }
                })()}
              </div>
            </div>
          )}
          
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
            {isPassed ? (
              isUserTakingOwnTest ? (
                // PASSED OWN TEST - Show only RETAKE TEST button
                <button 
                  onClick={this.handleCancelSubmission}
                  style={{
                    backgroundColor: '#2196F3',
                    color: 'white',
                    border: 'none',
                    padding: '6px 12px',
                    fontSize: '11px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    minWidth: '80px',
                    height: '32px'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#1976D2'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#2196F3'}
                >
                  RETAKE TEST
                </button>
              ) : (
                // PASSED REGULAR TEST - Show Submit (and Retry if allowed)
                <>
                  <button 
                    onClick={this.handleConfirmSubmission}
                    style={{
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      border: 'none',
                      padding: '6px 12px',
                      fontSize: '11px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      minWidth: '80px',
                      height: '32px'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#45a049'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#4CAF50'}
                  >
                    OK
                  </button>
                  {(() => {
                    // Only show CANCEL if we know there are retries left
                    const retriesLeft = (this.props.retryInfo && typeof this.props.retryInfo.retriesLeft === 'number')
                      ? this.props.retryInfo.retriesLeft
                      : Math.max(0, ((this.props.maxAttempts || 0) - (this.props.currentAttempt || 0)));
                    const retriesAvailable = retriesLeft > 0;
                    if (!retriesAvailable) return null;
                    return (
                      <button 
                        onClick={this.handleCancelSubmission}
                        style={{
                          backgroundColor: '#f44336',
                          color: 'white',
                          border: 'none',
                          padding: '6px 12px',
                          fontSize: '11px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontWeight: 'bold',
                          minWidth: '80px',
                          height: '32px'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#da190b'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#f44336'}
                      >
                        CANCEL
                      </button>
                    );
                  })()}
                </>
              )
            ) : (
              // FAILED TEST - Show Redo/Exit options (buttons only, retry info is above)
              <>
                {(() => {
                  // Calculate retry availability based on difficulty
                  const testDifficulty = this.props.testComplexity || this.props.difficulty || 'basic';
                  const maxRetryAttempts = getMaxRetryAttempts(testDifficulty);
                  const difficultyInfo = getDifficultyInfo(testDifficulty);
                  
                  // Check if retries are disabled due to difficulty or attempts exhausted
                  const retriesDisabled = maxRetryAttempts === 0 || (this.props.retryInfo && !this.props.retryInfo.canRetry);
                  
                  return (
                    <button 
                      onClick={this.handleCancelSubmission}
                      disabled={retriesDisabled}
                      style={{
                        backgroundColor: retriesDisabled ? '#cccccc' : '#2196F3',
                        color: 'white',
                        border: 'none',
                        padding: '6px 12px',
                        fontSize: '11px',
                        borderRadius: '4px',
                        cursor: retriesDisabled ? 'not-allowed' : 'pointer',
                        fontWeight: 'bold',
                        minWidth: '80px',
                        height: '32px'
                      }}
                      onMouseOver={(e) => {
                        if (!retriesDisabled) {
                          e.target.style.backgroundColor = '#1976D2';
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!retriesDisabled) {
                          e.target.style.backgroundColor = '#2196F3';
                        }
                      }}
                    >
                      {maxRetryAttempts === 0 
                        ? 'NO RETRY'
                        : (this.props.retryInfo && !this.props.retryInfo.canRetry) 
                          ? 'NO RETRY' 
                          : 'RETRY'
                      }
                    </button>
                  );
                })()}
                
                <button 
                  onClick={this.handleExitFailedTest}
                  style={{
                    backgroundColor: '#757575',
                    color: 'white',
                    border: 'none',
                    padding: '6px 12px',
                    fontSize: '11px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    minWidth: '80px',
                    height: '32px'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#616161'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#757575'}
                >
                  EXIT
                </button>
              </>
            )}
          </div>
        </div>
      );
    }

    // Show final results after user has made their choice
    return (
      <React.Fragment>
      { this.props.typeofSurvey==="T" ?
             <div style={{
                width:'100%', 
                textAlign: 'center',
                backgroundColor: '#ffffff',
                padding: '15px'
              }}>
        <div style={{ color: finalP, fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>
          {isPassed ? "PASSED!" : "FAILED!"}
        </div>
        <div style={{ color: finalP, marginBottom: '8px' }}>
          <b>Test Analysis:</b> Correct: {this.props.counterCorrectAnswers} | Wrong: {this.props.counterIncorrectAnswers}
        </div>
        <div style={{ color: finalP, fontSize: '14px', marginBottom: '8px' }}>
         {this.props.personName + ' ' + this.props.personLname} of {this.props.companyName}
        </div>
        
        {this.isOwnTest() ? (
          // Special display for test creators
          <div style={{ color: '#ff9800', marginTop: '10px', backgroundColor: '#fff3e0', padding: '15px', borderRadius: '8px', border: '2px solid #ffcc80' }}>
            <div style={{ fontSize: '16px', marginBottom: '5px' }}>
              <b>📝 Test Creator Preview</b>
            </div>
            <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
              You are viewing your own test. No points awarded and no submission recorded.
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>
              You can retake this test anytime to review your questions and answers.
            </div>
          </div>
        ) : (
          // Normal display for regular test takers
          isPassed ? (
            userSubmitted ? (
              this.props.userdata?.execmember === true ? (
                <div style={{ color: finalP, marginTop: '10px' }}>
                  <div style={{ fontSize: '16px', marginBottom: '5px' }}>
                    <b>🎉 LC Earned: </b><span style={{ color: finalP, fontSize: '30px', fontWeight: 'bold' }}>{lcEarned}</span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    ({getDifficultyInfo(this.props.testComplexity || this.props.difficulty || 'basic').pointsPerAnswer} LC per correct answer, max 0.5 LC)
                  </div>
                </div>
              ) : (
                <div style={{ color: '#ff9800', marginTop: '10px' }}>
                  <div style={{ fontSize: '16px', marginBottom: '5px' }}>
                    <b>⭐ Test Passed!</b>
                  </div>
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    Only Executive Club Members can earn LC from tests
                  </div>
                </div>
              )
            ) : (
              <div style={{ color: '#999', marginTop: '10px' }}>
                <div style={{ fontSize: '16px', marginBottom: '5px' }}>
                  <b>❌ Test Cancelled</b>
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  You chose to redo the test. No LC allocated.
                </div>
              </div>
            )
          ) : (
            <div style={{ color: finalP, marginTop: '10px' }}>
              <b>Points Added:</b> <span style={{ fontSize: '30px', fontWeight: 'bold' }}>0</span>
            </div>
          )
        )}
      </div>
      :
      <div style={{ textAlign: 'center', padding: '20px' }}>     
        <div style={{ color: finalP, marginBottom: '10px' }}>
         Thank You for completing the survey.
        </div>
        <div style={{ color: finalP, fontSize: '14px' }}>
         {this.props.personid} of {this.props.companyID}
        </div>
      </div>
      }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    collectTest: state.collectTest.collectTest
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showToast: params => dispatch(showToast(params)),
    appendTest: params => dispatch(appendTest(params)),
    addMorePoints: params => dispatch(addMorePoints(params)),
    updateTestAttempt: params => dispatch(updateTestAttempt(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FinalScope);

